import SupporterList from './SupporterList';

export default SupporterList;
